import { IconBrandYoutube, IconBrandInstagram, IconBrandWhatsapp, IconMail, IconPhone, IconBrandFacebook, IconBrandTripadvisor } from "@tabler/icons-react"
import { Link } from "react-router-dom"
import { BASE_ASSETS_URL } from "../utils/constants.js"

const getFarmmagazineNameInLang = (language) => {
    switch (language) {
        case "it-IT":
            return "Drockerhof_Hofmappe_it-IT"
        default:
            return "Drockerhof_Hofmappe_de-DE"
    }
}

const Footer = ({ text, settings }) => {
    const drockerhofLogo = text.navLogo ? require(`../assets/${text.footerLogo}.webp`) : null
    const southTyrolLogo = require("../assets/suedtirol-logo.webp") || null
    const funesLogo = require("../assets/funes-logo.webp") || null
    const guestPassLogo = require("../assets/guest-pass-logo.webp") || null
    const slowFoodLogo = require("../assets/slow-food-logo.webp") || null
    const furchettaLogo = require("../assets/furchetta-logo.webp") || null
    const organicLogo = require("../assets/organic-logo.webp") || null

    const socialsWidth = 34;
    const socialsHeight = 34;

    let guestPassUrl
    switch (settings.language) {
        case "it-IT":
            guestPassUrl = "https://www.suedtirol.info/it/it/information/suedtirol-guest-pass"
            break
        case "en-US":
            guestPassUrl = "https://www.suedtirol.info/en/en/information/suedtirol-guest-pass"
            break
        default:
            guestPassUrl = "https://www.suedtirol.info/de/de/information/suedtirol-guest-pass"
            break
    }

    // Schema.org structured data for organization
    const organizationSchema = {
        "@context": "https://schema.org",
        "@type": "LodgingBusiness",
        "name": "Drockerhof",
        "image": "https://www.drockerhof.it/assets/images/drockerhof_entrance_1.jpg",
        "url": "https://www.drockerhof.it",
        "logo": "https://www.drockerhof.it/assets/images/drockerhof_logo_de.jpg",
        "priceRange": "$$",
        "sameAs": [
            "https://www.youtube.com/@Drockerhof",
            "https://www.facebook.com/profile.php?id=61558862037339",
            "https://www.instagram.com/drockerhof/"
        ],
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "San Giacomo 18",
            "addressLocality": "Funes",
            "addressRegion": "South Tyrol",
            "postalCode": "39040",
            "addressCountry": "IT"
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": 46.65406102851609,
            "longitude": 11.650029741684827
        },
        "telephone": "+390472840030",
        "email": "info@drockerhof.it",
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+390472840030",
            "contactType": "customer service",
            "email": "info@drockerhof.it",
            "availableLanguage": ["German", "Italian", "English"]
        },
        "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
                "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
            ],
            "opens": "08:00",
            "closes": "20:00"
        }
    }

    return (
        <footer className="container mt-5" itemScope itemType="https://schema.org/WPFooter">
            <script type="application/ld+json">
                {JSON.stringify(organizationSchema)}
            </script>
            <div className="row mb-3">
                <address className="col" itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                    <img src={drockerhofLogo} alt="Drockerhof Logo" width="150" height="140" className="d-inline-block align-text-top" loading="lazy" />
                    <p className="fw-lighter text-left mb-1" itemProp="name">Drockerhof</p>
                    <p className="fw-lighter text-left mb-1" itemProp="streetAddress">{text.footerAddress1}</p>
                    <p className="fw-lighter text-left mb-1" itemProp="addressLocality">{text.footerAddress2}</p>
                    <p className="fw-lighter text-left mb-1" itemProp="postalCode">{text.footerAddress3}</p>
                </address>
                <nav className="col" aria-label="Footer Navigation">
                    <ul className="list-group list-group-flush mb-3">
                        <li className="list-group-item text-left">
                            <a className="link-underline link-underline-opacity-0" href={`${BASE_ASSETS_URL}documents/${getFarmmagazineNameInLang(settings.language)}.pdf`} target="_blank" rel="noreferrer" aria-label="Download our Farm Magazine (PDF)">
                                {text.footerFarmmagazine}
                            </a>
                        </li>
                        <li className="list-group-item text-left"><Link className="link-underline link-underline-opacity-0" to="arrival">{text.footerArrival}</Link></li>
                        <li className="list-group-item text-left"><Link className="link-underline link-underline-opacity-0" to="prices">{text.footerPrices}</Link></li>
                    </ul>
                    <div className="row mb-2">
                        <div className="col-6 col-md-4 col-xl-2 text-center mb-4 mb-xl-2">
                            <a className="link-underline link-underline-opacity-0" href={`https://wa.me/+393420302036?text=${text.whatsappMessage}`} target="_blank" rel="noreferrer" aria-label="Drockerhof WhatsApp Contact">
                                <IconBrandWhatsapp width={socialsWidth} height={socialsHeight} /><br />
                                WhatsApp
                            </a>
                        </div>
                        <div className="col-6 col-md-4 col-xl-2 text-center mb-4 mb-xl-2">
                            <a className="link-underline link-underline-opacity-0" href="mailto:info@drockerhof.it" target="_blank" rel="noreferrer" aria-label="Drockerhof E-mail Contact">
                                <IconMail width={socialsWidth} height={socialsHeight} /><br />
                                Email
                            </a>
                        </div>
                        <div className="col-6 col-md-4 col-xl-2 text-center mb-4 mb-xl-2">
                            <a className="link-underline link-underline-opacity-0" href="tel:+390472840030" target="_blank" rel="noreferrer" aria-label="Drockerhof Phone Contact">
                                <IconPhone width={socialsWidth} height={socialsHeight} /><br />
                                {text.footerCallUs}
                            </a>
                        </div>
                        <div className="col-6 col-md-4 col-xl-2 text-center mb-4 mb-xl-2">
                            <a className="link-underline link-underline-opacity-0" href="https://www.youtube.com/@Drockerhof" target="_blank" rel="noreferrer" aria-label="Drockerhof Youtube Channel">
                                <IconBrandYoutube width={socialsWidth} height={socialsHeight} /><br />
                                YouTube
                            </a>
                        </div>
                        <div className="col-6 col-md-4 col-xl-2 text-center mb-4 mb-xl-2">
                            <a className="link-underline link-underline-opacity-0" href="https://www.facebook.com/profile.php?id=61558862037339" target="_blank" rel="noreferrer" aria-label="Drockerhof Facebook Profile">
                                <IconBrandFacebook width={socialsWidth} height={socialsHeight} /><br />
                                Facebook
                            </a>
                        </div>
                        <div className="col-6 col-md-4 col-xl-2 text-center mb-4 mb-xl-2">
                            <a className="link-underline link-underline-opacity-0" href="https://www.instagram.com/drockerhof/" target="_blank" rel="noreferrer" aria-label="Drockerhof Instagram Channel">
                                <IconBrandInstagram width={socialsWidth} height={socialsHeight} /><br />
                                Instagram
                            </a>
                        </div>
                        <div className="col-6 col-md-4 col-xl-2 text-center mb-4 mb-xl-2">
                            <a className="link-underline link-underline-opacity-0" href="https://www.tripadvisor.de/Hotel_Review-g1207472-d33068087-Reviews-Drockerhof-Funes_Province_of_South_Tyrol_Trentino_Alto_Adige.html" target="_blank" rel="noreferrer" aria-label="Drockerhof Tripadvisor Page">
                                <IconBrandTripadvisor width={socialsWidth} height={socialsHeight} /><br />
                                Tripadvisor
                            </a>
                        </div>
                    </div>
                </nav>
            </div>
            <section className="row mb-3" aria-label="Our Partners and Certifications">
                <a className="col drocker-footer-logo" href="https://www.suedtirol.info/" target="_blank" rel="noreferrer" aria-label="Visit South Tyrol Tourism Website">
                    <img src={southTyrolLogo} alt="Suedtirol logo" style={{ width: "125px", height: "100px" }} loading="lazy" />
                </a>
                <a className="col drocker-footer-logo" href="https://www.villnoess.com/" target="_blank" rel="noreferrer" aria-label="Visit Funes Tourism Website">
                    <img src={funesLogo} alt="Funes Logo" style={{ height: "49px", width: "200px" }} loading="lazy" />
                </a>
                <a className="col drocker-footer-logo" href={guestPassUrl} target="_blank" rel="noreferrer" aria-label="Learn about the South Tyrol Guest Pass benefits">
                    <img src={guestPassLogo} alt="GuestPass Logo" style={{ height: "63px", width: "200px" }} loading="lazy" />
                </a>
                <a className="col drocker-footer-logo" href="https://www.fondazioneslowfood.com/" target="_blank" rel="noreferrer" aria-label="Visit Slow Food Foundation Website">
                    <img src={slowFoodLogo} alt="Slow Food Logo" style={{ height: "100px", width: "143px" }} loading="lazy" />
                </a>
                <a className="col drocker-footer-logo" href="http://www.furchetta.it/de/slow-food-travel-villnoess.html" target="_blank" rel="noreferrer" aria-label="Learn about Slow Food Travel in Villnöss">
                    <img src={furchettaLogo} alt="Furchetta Logo" style={{ height: "100px", width: "133px" }} loading="lazy" />
                </a>
                <a className="col drocker-footer-logo" href="https://www.abcert.it/" target="_blank" rel="noreferrer" aria-label="Visit ABCert Organic Certification Website">
                    <img src={organicLogo} alt="Organic / Bio Logo" style={{ height: "100px", width: "150px" }} loading="lazy" />
                </a>
            </section>
            <div className="row mb-3">
                <p className="fw-lighter text-center">
                    © {new Date().getFullYear()} Drockerhof -
                    <Link to="privacy">{text.footerPrivacy}</Link> -
                    <Link to="legalinfo">{text.footerLegalNotes}</Link> -
                    <Link to="sitemap">{text.footerSitemap}</Link> -
                    {text.footerFiscalCode} <span itemProp="taxID">{text.footerFiscalCode} MSSGTH70R31B160H</span>
                </p>
                <p className="fw-lighter text-center">
                    <span itemProp="identifier">CIR: 021033-00000568</span> - <span itemProp="identifier">CIN: IT021033B5WEAQG6Y8</span>
                </p>
            </div>
        </footer>
    )
}

export default Footer
